var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ex-mark"},[_c('i',{on:{"click":_vm.tipView}},[_vm._v("툴팁")]),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.tipOn),expression:"tipOn"}],on:{"click":_vm.tipView}},[_vm._v(_vm._s(_vm.tipTxt))])])}
var staticRenderFns = []

export { render, staticRenderFns }